<template>
  <div>
    <PageHeader :page_title="page_title"/>
    <pSpinner v-if="loading"></pSpinner>
    <template v-if="!loading">
      <v-tabs  v-model="active_tab1" color="grey  lighten-3" dark  slider-color = "primary" >
        <v-tab ripple class = "black--text ml-4" v-for="tab of tabs"  :key="tab.id"  @click="redirectTo(tab.id,tab.link)" >
        {{tab.name}}
        </v-tab>
      </v-tabs>
      <v-container fluid>
      
        <v-card>
          <v-form ref="form">
            <v-container fluid>
              <v-layout row wrap>
                <template>
                  <v-flex xs12 sm4>
                  <v-text-field :value="fd.account_id" label="Account Number" readonly></v-text-field>
                  </v-flex>
                  
                  <v-flex xs12 sm4>
                  <v-text-field :value="fd_details.status" label="Status" readonly ></v-text-field>
                  </v-flex>
                  
                  <v-flex xs12 sm4 v-if="fd_details.status == 'Closed'">
                  <v-text-field :value="fd_details.closed_on" label="Closed On" readonly></v-text-field>
                  </v-flex>
                  
                  
                  <v-flex xs12 sm4>
                  <v-text-field :value="fd_details.activated_on" label="Deposit Date" readonly></v-text-field>
                  </v-flex>
                  
                  <v-flex xs12 sm4>
                  <v-text-field :value="fd_details.mode_operation" label="Account Type" readonly ></v-text-field>
                  </v-flex>
                  
                  <v-flex xs12 sm4>
                  <v-text-field :value="fd.office_name" label="Branch" readonly ></v-text-field>
                  </v-flex>
                  
                  
                  
                  <v-flex xs12 sm4>
                  <v-text-field :value="fd.interest" label="Interest Rate" readonly ></v-text-field> 
                  </v-flex>
                  
                  
                  <v-flex xs12 sm4>
                  <v-text-field :value="fd_details.account_balance" label="Account Balance" readonly></v-text-field>
                  </v-flex>
                  
                  <v-flex xs12 sm4>
                  <v-text-field :value="fd_details.zero_balance" label="Zero Balance" readonly></v-text-field>
                  </v-flex>
                  
                  </template>
                </v-layout>
            </v-container>
          </v-form>
        </v-card>
      </v-container>
    </template>
  </div>

</template>

<script>

  import axios from 'axios'

  import NoData from '@/components/NoData'
  
  import pSpinner from '@/components/pSpinner';

  import global from '@/components/rbconstants';

  import PageHeader from '@/components/PageHeader'

  export default {

    components : {

        NoData : NoData,
        
        PageHeader : PageHeader,
        
        pSpinner : pSpinner,
    },  
    
  
    mounted() {
      
      this.getDataFromApi()
      
      .then(data => {
        
        this.fd_details = data.fd_details.sbd_details;
        
        this.fd = data.fd_details.sbd;
        
        this.loading = false;
        
      })
    },
      
    data: () => ({
        
        fd_loans_table_headers : [{ text: '#'}, { text : 'Account Number'}, { text : 'Status'}, { text : 'Amount'}, { text : 'Tenure'},
                                 { text : 'Interest'}, { text : 'Reference ID'}, { text : 'Created On'}, { text : 'Loan Date' }],
        
        nominee_table_headers  : [{ text: '#'}, { text : 'FIrst Name'}, { text : 'Last Name'}, { text : 'DOB'}, { text : 'Mobile Number'},
                                 { text : 'Address'}, { text : 'Relation'}],
        
        page_title : "Savings Bank Deposit",
        
        fd_details : [],
        
        fd : [],
        
        fd_loans : [],
        
        nominees : [],
        
        active_tab1: 0,
        
        tabs: [
          
          { id: 1, name: "Account Details", route: "deposits/savings/:id" },
          { id: 2, name: "Ledger", route: "deposits/savings/:id/ledger" }
        
        ],
        
        loading : false,
    }),
    
  	methods : {
  	    
      getDataFromApi() {
        
        this.loading = true;
        
        this.table_loading = true
        
        return new Promise((resolve, reject) => {
          
          var app = this;
          
          var form_post_data = {};
          
          var link = global.links.savings_deposit;
          
          var deposit_id = this.$route.params.id
          
          link = link.replace(':id',deposit_id);
          
          axios.post(link, {
          
            params : form_post_data,
          
          }, { headers : global.header }) 
          
          .then(function (response) {
           
            if(response.status == 200) {
              
              var fd_details = response.data.data;
              
              setTimeout(() => {
                
                app.table_loading = false
                
                resolve({
                  
                  fd_details
                
                })
              
              }, 1000)
            
            }
          
          }) .catch(function (error) {
            
            if(error.response.data.error.code == 400) {
              
              app.$router.push({ name: 'DepositList',  params: { alert: true}})

            }
          
            app.loading = false;
          
          });
        
        });
      
      },
      
      redirectTo(id, link) {
                  
        if(id == 1) {
          
          var id = this.$route.params.id;
          
          this.$router.push({ name: 'SavingsDeposit', params: { id: id}});
        
        } else if(id == 2) {
          
          var id = this.$route.params.id;
          
          this.$router.push({ name: 'SavingsDepositLedger', params: { id: id}});
        
        }
      
      }
          
  	},
	
	
  }
  
</script>
